/// <amd-module name="TFS/Views/ProjectOverviewPage/ProjectOverviewTab/Actions/ActionsHub" />
import { Action } from "VSS/Reflux/Action";

import { AboutProjectData, AboutRegionInfo, Permissions } from "TFS/Views/ProjectOverviewPage/ProjectOverviewTab/Models";

export class ActionsHub {
    public aboutProjectDataLoaded = new Action<AboutProjectData>();
    public aboutProjectDataLoadFailed = new Action<void>();

    public allProjectTagsInCollectionLoaded = new Action<string[]>();
    public projectTagsUpdated = new Action<string[]>();
    public projectTagsUpdateFailed = new Action<void>();
    public projectTagsUpdateStarted = new Action<void>();
    public projectTagsNotUpdating = new Action<void>();

    public projectDescriptionUpdated = new Action<string>();
    public projectDescriptionUpdateFailed = new Action<string | undefined>();
    public projectDescriptionUpdateStarted = new Action<void>();
    public projectDescriptionNotUpdating = new Action<void>();

    public readmeSettingUpdated = new Action<AboutRegionInfo>();
    public readmeSettingUpdateFailed = new Action<void>();
    public readmeSettingUpdateStarted = new Action<void>();
    public readmeSettingNotUpdating = new Action<void>();

    public permissionsLoaded = new Action<Permissions>();
}
